import { render, staticRenderFns } from "./InputChangeOrder.vue?vue&type=template&id=621b9e87&scoped=true&lang=pug"
import script from "./InputChangeOrder.vue?vue&type=script&lang=ts"
export * from "./InputChangeOrder.vue?vue&type=script&lang=ts"
import style0 from "./InputChangeOrder.vue?vue&type=style&index=0&id=621b9e87&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "621b9e87",
  null
  
)

export default component.exports